import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.2) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
export function FinalCTASection() {
  const {
    ref,
    inView
  } = useInView();
  const scrollToCTA = () => {
    document.getElementById('cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="section-cream py-20 lg:py-28" ref={ref} data-id="element-43">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center" data-id="element-44">
        <div className="transition-all duration-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-45">
          <h2 className="font-heading font-black mb-4 leading-tight" style={{
          color: '#1B3A5C',
          fontSize: 'clamp(1.8rem, 4vw, 3rem)'
        }} data-id="element-46">
            La experiencia es el único activo
            <br data-id="element-47" />
            que no se puede comprar.
          </h2>
          <p className="font-heading italic text-xl mb-8" style={{
          color: '#C9A84C'
        }} data-id="element-48">
            Es hora de cobrar por ella.
          </p>

          <div className="gold-divider max-w-xs mx-auto mb-8" data-id="element-49" />

          <p className="font-body text-lg leading-relaxed mb-10" style={{
          color: '#3A4A5A'
        }} data-id="element-50">
            Puedes seguir actualizando LinkedIn y esperando un milagro. O puedes
            usar este sistema para construir tu propia{' '}
            <strong style={{
            color: '#1B3A5C'
          }} data-id="element-51">
              libertad financiera desde el salón de tu casa
            </strong>
            , con tu café y bajo tus términos.
          </p>

          <button onClick={scrollToCTA} className="inline-flex items-center gap-3 px-10 py-5 rounded-xl font-body font-black text-base tracking-wide transition-all duration-200 hover:scale-105 hover:brightness-110" style={{
          backgroundColor: '#1B3A5C',
          color: '#C9A84C',
          border: '2px solid #C9A84C',
          boxShadow: '0 8px 30px rgba(27,58,92,0.25)'
        }} data-id="element-52">
            Empieza Tu Reinvención Hoy →
          </button>

          <p className="font-body text-sm mt-4" style={{
          color: '#8A9AAA'
        }} data-id="element-53">
            🔒 Garantía de 30 días · Pago único · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}